export var NavigationAction;
(function (NavigationAction) {
    // eslint-disable-next-line no-unused-vars
    NavigationAction[NavigationAction["Previous"] = -1] = "Previous";
    // eslint-disable-next-line no-unused-vars
    NavigationAction[NavigationAction["Next"] = 1] = "Next";
})(NavigationAction || (NavigationAction = {}));
